import { Button, StatusBox, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import { IUserProviderItem } from 'types/provider.types';
import queryClient from '../../../../../query-client';

interface ProviderPendingProps {
  items: IUserProviderItem[];
  onContinue: () => void;
}

const ProviderPending: React.FunctionComponent<ProviderPendingProps> = ({ items, onContinue }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  if (items.length === 0) {
    return null;
  }

  const provider = items[0].provider;
  const creationStatus = provider.status;
  const userStatusStatus = items[0].status;
  const providerName = (
    <>
      {provider.name}
      <br />
      {`${provider.address.address}, ${provider.address.postCode}, ${provider.address.city}`}
    </>
  );
  const timeline = items[0].timeline;

  if (
    creationStatus === 'pending' ||
    creationStatus === 'pendingWithGuarator' ||
    userStatusStatus === 'pending'
  ) {
    return (
      <>
        <StatusBox
          title={formatMessage({ id: 'provider.onboarding.pending.title' })}
          type="processing"
          description={providerName}
        />
        <div style={{ textAlign: 'center', marginTop: theme.spacings.text.XL }}>
          <Button
            loading={queryClient.isFetching('user-providers') > 0}
            block={false}
            onClick={() => {
              queryClient.fetchQuery('user-providers');
            }}
          >
            {formatMessage({ id: 'provider.onboarding.pending.check.status' })}
          </Button>
        </div>
      </>
    );
  }

  if (creationStatus === 'approved' && userStatusStatus === 'approved') {
    return (
      <>
        <StatusBox
          title="Vytvorenie účtu nového poskytovateľa bolo úspešné"
          type="success"
          description={providerName}
        />
        <div style={{ textAlign: 'center', marginTop: theme.spacings.text.XL }}>
          <Button
            block={false}
            onClick={() => {
              queryClient.fetchQuery('user-providers');
              onContinue();
            }}
          >
            PREJSŤ DO PROFILU
          </Button>
        </div>
      </>
    );
  }

  if (creationStatus === 'rejected' || userStatusStatus === 'rejected') {
    const error = timeline.find((t) => t.status === 'rejected');
    return (
      <>
        <StatusBox
          title="Vytvorenie účtu nového poskytovateľa nebolo úspešné"
          type="failed"
          description={providerName}
        />
        <Typography style={{ color: theme.color.tint.error }}>{error?.note}</Typography>
      </>
    );
  }

  return null;
};

export default ProviderPending;
